import { Divider } from '@material-ui/core';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { green, grey } from '@material-ui/core/colors';
import {
  ContainerColumn,
  ContainerCount,
  ContainerImage,
  ContainerRow,
  HoverBox,
  List,
  PDV,
  PlaceName,
  Small,
} from './styles';
import ManagerUser from '../../assets/usersManeger.png';
import DayRounded from '../daysRounded';
import IOSSwitch from '../IOsSwitch';

interface Props {
  name: string;
  photo: string;
  address: string;
  numberAddress: string;
  contry: string;
  count: number;
  checked: boolean;
  onPress: Function;
  isPDV: boolean;
  navigation: Function;
  turnsWeek: Array<string>;
}

const ItemPlace: React.FC<Props> = ({
  photo,
  name,
  address,
  numberAddress,
  contry,
  count,
  checked,
  onPress,
  isPDV,
  navigation,
  turnsWeek,
}) => {
  const handleCount = () => {
    if (count >= 99) {
      return '99+';
    }
    return count;
  };
  return (
    <HoverBox style={{ opacity: !checked ? 0.4 : undefined }}>
      <Divider />
      <List onClick={() => navigation()}>
        <ContainerImage>
          <LazyLoadImage
            alt="Imagem não carregou"
            src={photo}
            loading="eager"
            style={{
              height: 80,
              minWidth: 80,
              maxWidth: 80,
              borderRadius: 8,
              backgroundSize: 'contain',
            }}
          />
          <ContainerColumn>
            {isPDV ? <PDV>PDV</PDV> : null}
            <PlaceName>{name}</PlaceName>
            <Small>{`${address}, ${numberAddress}, ${contry}`}</Small>
          </ContainerColumn>
        </ContainerImage>
        <DayRounded turnsWeek={turnsWeek} />
      </List>
      <ContainerRow>
        <ContainerCount>
          <LazyLoadImage
            alt="Imagem não carregou"
            src={ManagerUser}
            style={{ height: 16, width: 14, marginLeft: 25 }}
          />
          <small style={{ marginLeft: 6, marginTop: 4 }}>{handleCount()}</small>
        </ContainerCount>
        <IOSSwitch check={checked} onClick={() => onPress()} />
      </ContainerRow>
    </HoverBox>
  );
};
export default ItemPlace;
